import {
  GET_DOCUMENTOS
} from "../../types";

export default (state, action) => {
  switch (action.type) {
    case GET_DOCUMENTOS:
      return {
        ...state,
        documentos: action.payload
      };
    default:
      return state;
  }
};
